import { useCreate } from 'react-admin';
import { ScmTag, ScmTagVis } from '../types';
import { TagDialog } from './TagDialog';

type TagCreateModalProps = {
    tipo: string;
    open: boolean;
    onClose(): void;
    onSuccess?(tag: ScmTag): Promise<void>;
};

export function TagCreateModal({
    tipo,
    open,
    onClose,
    onSuccess,
}: TagCreateModalProps) {
    const [create] = useCreate<ScmTag>();

    const handleCreateTag = async (data: Pick<ScmTag, 'descricao_tag' | 'color' | 'visibilidade'>) => {
        await create(
            'scmtags',
            { data },
            {
                onSuccess: async tag => {
                    await onSuccess?.(tag);
                },
            }
        );
    };

    return (
        <TagDialog
            open={open}
            title={tipo}
            onClose={onClose}
            onSubmit={handleCreateTag}
        />
    );
}
